import i18next from "i18next";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Navbar } from "../../Components/Navbar/Navbar";
import { Meta } from "../../Components/Helpers/Meta";
import { useParams } from "react-router-dom";
import InvestorSidebar from "../../Components/InvestorSidebar/InvestorSidebar";
import "../../Components/InvestorSidebar/InvestorLayout.css";          
import "./BoardMembers.style.css";                              
import { members } from "./BoardMembersList";

const BoardMembers = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const L = i18next.language?.startsWith("tr") ? "tr" : "en";

  // sadece yönetim kurulu
  const yonetimUyeleri = members.filter(m => m.classfield === "yonetim");

  // modal
  const [selected, setSelected] = useState(null);
  const openModal = (m) => { setSelected(m); document.body.style.overflow = "hidden"; };
  const closeModal = () => { setSelected(null); document.body.style.overflow = ""; };

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") closeModal(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div>
      <Meta
        title={t("board-of-directors") || "Yönetim Kurulu"}
        description={t("board-of-directors") || "Yönetim Kurulu"}
        lang={lang}
      />
      <Navbar />

      <div className="c-wrapper">
        {/* Hero dokunulmaz */}
        <div className="c-hero">
          <div className="c-hero-background">
            <picture>
              <img
                className="c-hero-image"
                alt=""
                src={require("../../assets/hero/public-offering.jpg")}
                style={{ width: "100%" }}
              />
            </picture>
          </div>
          <div className="c-hero-body">
            <div className="c-about-caption">
              <div className="c-caption-section" style={{ color: "#000", textAlign: "center" }}>
                {t("investor-relations")}
              </div>
              <h1 className="c-caption-header" style={{ color: "#000" }}>
                {t("board-of-directors") || "Yönetim Kurulu"}
              </h1>
            </div>
          </div>
        </div>

        {/* SABİT: 280px sidebar + sabit içerik kolonu */}
        <div className="po-container">
          <InvestorSidebar />

          {/* içerik artık pol-content + pol-card içinde --artık değil -- */}
          <main className="board-content">
            
              <div className="board-grid">
                {yonetimUyeleri.map((m) => (
                  <button
                    key={m.id}
                    className="board-card"
                    onClick={() => openModal(m)}
                    aria-haspopup="dialog"
                    aria-label={`${m.name[L]} - ${m.title[L]}`}
                  >
                    <div className="board-photo-wrap">
                      <img src={m.photo} alt={m.name[L]} className="board-photo" />
                    </div>
                    <div className="board-name">{m.name[L]}</div>
                    <div className="board-title">{m.title[L]}</div>
                  </button>
                ))}
              </div>
            
          </main>
        </div>
      </div>

      {/* Modal (mevcut stil dosyasıyla birebir) */}
      {selected && (
        <div
          className="board-modal-overlay"
          role="dialog"
          aria-modal="true"
          onClick={(e) => { if (e.target.classList.contains("board-modal-overlay")) closeModal(); }}
        >
          <div className="board-modal">
            <button className="board-modal-close" onClick={closeModal} aria-label={t("close") || "Kapat"}>
              ×
            </button>
            <div className="board-modal-body">
              <img src={selected.photo} alt={selected.name[L]} className="board-modal-photo" />
              <h2 className="board-modal-name">{selected.name[L]}</h2>
              <div className="board-modal-title">{selected.title[L]}</div>
              <p className="board-modal-bio">{selected.bio[L]}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BoardMembers;
